import { render, staticRenderFns } from "./BannerSimpleBlock.vue?vue&type=template&id=68dd7d49&scoped=true&"
import script from "./BannerSimpleBlock.vue?vue&type=script&lang=js&"
export * from "./BannerSimpleBlock.vue?vue&type=script&lang=js&"
import style0 from "./BannerSimpleBlock.vue?vue&type=style&index=0&id=68dd7d49&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dd7d49",
  null
  
)

export default component.exports